module.exports = __webpack_public_path__ + "static/habStill1-b0dce569d22520a3b8df76b73eca4cc2.png";